export const ALL_CATEGORIES_SLUG = 'all'
export const PAGE_SIZE = 10
